import { api } from "../api/apiCore";
import { invalidateByPrefix } from '../utils/apiCache';

export function getCompanyGroups(userRole, company, getids) {
	const id = getids || '';
	let url;
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/partner/${company.partner}/companies/${company.name}/groups${id}`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${company.partner}/companies/${company.name}/groups${id}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company.name}/groups${id}`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${company.partner}/companies/${company.name}/groups${id}`;
		break;
	default:
		url = `/groups${id}`;
		break;
	}

	return api.get(url)
}


export function addGroup(data, user_role) {
	let url;
	switch (user_role) {
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'storage_manager':
	case 'custom_user':
		url = `/groups/${data.group_name}`;
		break;
	case 'system_admin':
		url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${data.company_name}/groups/${data.group_name}`;
		break;
	default:
		break;
	}

	return api.putForm(url);
}

export function deleteGroup (data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.group_name}`;
			break;
	}

	return api.delete(url);
}

export function getDevicesOfGroup(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/devices`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.group_name}/devices`;
			break;
	}

	return api.get(url)
}

export function addDeviceToGroup(data , device_id){
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.group_name}/devices/${device_id}`;
			break;
	}

	return api.putForm(url).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function removeDeviceFromGroup(data , device_id){
	let url;

	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/devices/${device_id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.group_name}/devices/${device_id}`;
			break;
	}

	return api.delete(url).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function getUsersOfGroup(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/users`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.group_name}/users`;
			break;
	}

	return api.get(url)
}


export function addUserToGroup(data, user_email){
	let url
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		default:
			url = `/groups/${data.group_name}/users/${user_email}`;
			break;
	}

	return api.putForm(url);
}


export function removeUserFromGroup(data, user_email){
	let url
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.group_name}/users/${user_email}`;
			break;
		default:
			url = `/groups/${data.group_name}/users/${user_email}`;
			break;
	}

	return api.delete(url);
}

export function editGroup(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.id}`;
			break;
	}

	const form = new FormData();
	form.append('group_name', data.group_name);

	return api.postForm(url, form);
}


export function getGroupData(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/groups/${data.id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/groups/${data.id}`;
			break;
	}

	return api.get(url)
}

export function toggleDriverToGroup(data) {
	const { driver_id, ...rest } = data;
	let url = `/driver/${driver_id}`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('drivers:');
		return res;
	});
}

export function getGroups(data) {
	const url = `/groups`;

	return api.get(url);
}
